import { FC, memo } from 'react'

import { useForm } from '@tanstack/react-form'
import { FF } from 'ui/components'
import { CompanySelect } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter'
import { TableFilterRow } from 'ui/temp/TableFilterRow'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import * as SC from './styles'

export const Filter: FC = memo(() => {
  const { data, search, onFilterChange } = useAlertsContext()
  const { relationshipOptions, form } = data

  const formApi = useForm({
    defaultValues: {
      monthlyAnalyticsCompanyID: form.monthlyAnalyticsCompanyID
    }
  })

  const clearForm = () => {
    formApi.reset()
    onFilterChange(
      {
        monthlyAnalyticsCompanyID: undefined,
        monthlyAnalyticsPage: 1
      },
      'monthlyAnalytics'
    )
  }

  const updateSearchParams = (newValue: Partial<AlertsPayload>) => {
    onFilterChange({ ...search, ...newValue, monthlyAnalyticsPage: 1 }, 'monthlyAnalytics')
  }

  const hasActiveFilters = Boolean(search.monthlyAnalyticsCompanyID)

  return (
    <FilterPanel isDirty={hasActiveFilters} onReset={clearForm} expanded={false}>
      <FilterWrapper>
        <TableFilterRow>
          <SC.ItemWrapper>
            <formApi.Field
              name="monthlyAnalyticsCompanyID"
              listeners={{
                onChange: ({ value }) => {
                  updateSearchParams({ monthlyAnalyticsCompanyID: value })
                }
              }}
              children={(field) => (
                <FF
                  field={field}
                  label="Relationships"
                  input={(inputProps) => (
                    <CompanySelect hideMyCompaniesFilter preloadedOptions={relationshipOptions} {...inputProps} />
                  )}
                />
              )}
            />
          </SC.ItemWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
})
